var _classCallCheck = require("/zeit/7a81658/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/zeit/7a81658/node_modules/@babel/runtime/helpers/createClass");

var axios = require('axios');

var _ZAPIURL = 'https://api.zhi1.tech'; //const _ZAPIURL = 'http://localhost:8888'

var Zhi1Obj =
/*#__PURE__*/
function () {
  "use strict";

  function Zhi1Obj(token) {
    _classCallCheck(this, Zhi1Obj);

    this._token = token;
    console.log(process.env.NODE_ENV);
    this._url = _ZAPIURL;
    this.setToken(token);
    return this;
  }

  _createClass(Zhi1Obj, [{
    key: "setToken",
    value: function setToken(token) {
      this._token = token;
    }
  }, {
    key: "hasToken",
    value: function hasToken() {
      if (this.token != undefined) {
        return false;
      } else return true;
    }
  }, {
    key: "feTracking",
    value: function feTracking(eventObj) {
      var _this = this;

      var id = eventObj.id;
      var val = eventObj.value;
      var increment = eventObj.increment;
      var labelRecord = eventObj.labelRecord;

      if (!window.Zhi1 || !window.Zhi1.u || !window.Zhi1.currentSession) {
        setTimeout(function () {
          _this.feTracking(eventObj);
        }, 1000);
        return;
      }

      var data = {
        id: id,
        value: val,
        increment: increment || 1,
        receiverId: this._token,
        uid: window.Zhi1.u,
        currentSession: window.Zhi1.currentSession
      };
      axios.post(this._url + '/maidian/update', data).then(function (response) {
        if (labelRecord) {
          _this.labelVideo(id);
        }
      }).catch(function (error) {
        console.error("次埋点信息还没有创建, 请到鹰眼后台先行创建");
      });
    }
  }, {
    key: "beTracking",
    value: function beTracking(eventName, val, memo, increment) {}
  }, {
    key: "labelVideo",
    value: function labelVideo(tagName, metadata, time) {
      var _this2 = this;

      if (!tagName) {
        alert('视频添加标签 name 参数出错');
      }

      if (window.Zhi1 && window.Zhi1.ws && window.Zhi1.ws.readyState === 1 && window.Zhi1.u) {
        var data = JSON.stringify({
          type: 'insertLabel',
          data: {
            name: tagName,
            meta: metadata || null,
            timestamp: time || Date.now()
          }
        });

        if (data.size > 1000) {
          console.error('视频插入标记信息太长,请优化, 来自 Zhi1.labelVideo');
          return;
        }

        window.Zhi1.ws.send(data);
        return;
      } else {
        setTimeout(function () {
          _this2.labelVideo(tagName, metadata, Date.now());
        }, 1000);
        return;
      }
    }
  }]);

  return Zhi1Obj;
}();

var API = function API() {
  "use strict";

  _classCallCheck(this, API);
};

var newZhi1 = function newZhi1(token) {
  return new Zhi1Obj(token);
};

module.exports = {
  Zhi1: newZhi1
};